import React, { Fragment } from "react";

const Markup = ({ renderField, Button, renderCheckbox, ...props }) => {
    const { name, planStayPeriod, isVisitOptional } = props;
    return (
        <Fragment>
            {renderField(name)}
            {renderField(planStayPeriod)}
            {renderCheckbox(isVisitOptional)}
            {!!Button && <Button />}
        </Fragment>
    );
};
export default Markup;
